// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-guardian-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #0f172a;
  background: linear-gradient(145deg, #fda4af 0%, #fb7185 100%);
  box-shadow: 0 8px 20px -10px rgba(244, 63, 94, 0.55);
  overflow: hidden;
  flex-shrink: 0;
}

.parent-guardian-avatar--father {
  background: linear-gradient(145deg, #7dd3fc 0%, #0284c7 100%);
  color: #0c4a6e;
  box-shadow: 0 8px 20px -10px rgba(2, 132, 199, 0.55);
}

.parent-guardian-avatar--tutor,
.parent-guardian-avatar--parent {
  background: linear-gradient(145deg, #fdba74 0%, #ea580c 100%);
  color: #7c2d12;
  box-shadow: 0 8px 20px -10px rgba(234, 88, 12, 0.55);
}

.parent-guardian-avatar__initial {
  position: absolute;
  right: 10%;
  bottom: 8%;
  min-width: 1.15em;
  height: 1.15em;
  padding: 0 0.2em;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: #0f172a;
  font-size: 0.55em;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/ParentGuardianAvatar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,6DAA6D;EAC7D,oDAAoD;EACpD,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,oDAAoD;AACtD;;AAEA;;EAEE,6DAA6D;EAC7D,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".parent-guardian-avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: #0f172a;\n  background: linear-gradient(145deg, #fda4af 0%, #fb7185 100%);\n  box-shadow: 0 8px 20px -10px rgba(244, 63, 94, 0.55);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.parent-guardian-avatar--father {\n  background: linear-gradient(145deg, #7dd3fc 0%, #0284c7 100%);\n  color: #0c4a6e;\n  box-shadow: 0 8px 20px -10px rgba(2, 132, 199, 0.55);\n}\n\n.parent-guardian-avatar--tutor,\n.parent-guardian-avatar--parent {\n  background: linear-gradient(145deg, #fdba74 0%, #ea580c 100%);\n  color: #7c2d12;\n  box-shadow: 0 8px 20px -10px rgba(234, 88, 12, 0.55);\n}\n\n.parent-guardian-avatar__initial {\n  position: absolute;\n  right: 10%;\n  bottom: 8%;\n  min-width: 1.15em;\n  height: 1.15em;\n  padding: 0 0.2em;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.92);\n  color: #0f172a;\n  font-size: 0.55em;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
